import { TrustTeamMemberView } from "@/shared/modules/typescript-trustapi-client/models";
import { Module } from "vuex";

const trustMemberStoreModule: Module<any, any> = {
  state: {
    selectedTrustTeamMember: {},
  },
  mutations: {
    setSelectedTrustTeamMember(state, i: TrustTeamMemberView) {
      state.selectedTrustTeamMember = i;
    }
  },
  actions: {
    setSelectedTrustTeamMember({ commit }, i: TrustTeamMemberView) {
      commit('setSelectedTrustTeamMember', i);
    }
  },
  getters: {
    getSelectedTrustTeamMember: (state) => state.selectedTrustTeamMember,
  }
}
export default trustMemberStoreModule;